// Sanitizers passed to LogRocket.init so session replays never carry the
// shopper's bearer token or PII to the vendor.
//
// Request/response bodies are dropped wholesale rather than field-redacted:
// auth endpoints return `accessToken`, and nearly every other endpoint returns
// order, address, refund or gift-card data. Method, URL, status and timings are
// kept, which is what replay debugging actually relies on.

const SENSITIVE_HEADERS = [
  'authorization',
  'cookie',
  'set-cookie',
  'x-csrftoken',
  'x-api-key',
];

export const REDACTED = '[REDACTED]';

function sanitizeHeaders(headers) {
  if (!headers || typeof headers !== 'object') return headers;

  return Object.keys(headers).reduce((acc, key) => {
    acc[key] = SENSITIVE_HEADERS.includes(key.toLowerCase())
      ? REDACTED
      : headers[key];
    return acc;
  }, {});
}

export function requestSanitizer(request) {
  if (!request) return request;

  return {
    ...request,
    headers: sanitizeHeaders(request.headers),
    body: null,
  };
}

export function responseSanitizer(response) {
  if (!response) return response;

  return {
    ...response,
    headers: sanitizeHeaders(response.headers),
    body: null,
  };
}
